import React from 'react';
import { motion } from 'framer-motion';
import Navbar from './Navbar';
import LeftImage from '../../assets/left.webp';
import RightImage from '../../assets/right.webp';
import SyntheticaImage from '../../assets/SYNTHETICA.webp';
import DetectiveImage from '../../assets/Detective.webp';
import About from './About';
import '../../styles/Home.css';
import LaunchIcon from '@mui/icons-material/Launch';
import { useNavigate } from 'react-router-dom';
import { auth } from '../../config/firebase';
import Rectangle19 from '../../assets/Rectangle 19.webp';
import Footer from './Footer';
import Model from './Model';

const Home = () => {
  const navigate = useNavigate();

  const handleTryus = () => {
    if (auth.currentUser) {
      navigate(`/essay-detector`);
    } else {
      navigate('/login');
    }
  };

  return (
    <div>
      <header>
        <Navbar />
      </header>

      <main>
        <section className="main-content">
          <div className="synthetica-container">
            {/* Wrap the synthetica image in a motion component */}
            <motion.img
              src={SyntheticaImage}
              alt="Synthetica Image"
              className="synthetica-image"
              initial={{ opacity: 0, scale: 0.5 }} // Initial animation properties
              animate={{ opacity: 1, scale: 1 }} // Animation properties on load
              transition={{ duration: 0.5 }} // Animation duration
            />
          </div>

          <div className="detective-container">
            <motion.img
              src={DetectiveImage}
              alt="Detective Image"
              className="detective-image"
              initial={{ opacity: 0, y: -50 }} // Initial animation properties
              animate={{ opacity: 1, y: 0 }} // Animation properties on load
              transition={{ duration: 0.5, delay: 0.6 }} // Animation duration and delay
            />
            <motion.div
              className="try-us-button"
              initial={{ opacity: 0, y: 50 }} // Initial animation properties
              animate={{ opacity: 1, y: 0 }} // Animation properties on load
              transition={{ duration: 0.5, delay: 0.8 }} // Animation duration and delay
              onClick={handleTryus}
              style={{ position: 'relative', cursor: 'pointer' }}
            >
              <img src={Rectangle19} alt="Try Synthetica" className="rectangle-image" />
              <div className="try-us-text">
                TRY SYNTHETICA <LaunchIcon className="launch-icon" />
              </div>
            </motion.div>
          </div>

          <div className="left-content">
            <motion.img
              src={LeftImage}
              alt="Left Image"
              initial={{ opacity: 0, x: -50 }} // Initial animation properties
              animate={{ opacity: 1, x: 0 }} // Animation properties on load
              transition={{ duration: 0.5, delay: 0.2 }} // Animation duration and delay
            />
          </div>

          <div className="right-content">
            <motion.img
              src={RightImage}
              alt="Right Image"
              initial={{ opacity: 0, x: 50 }} // Initial animation properties
              animate={{ opacity: 1, x: 0 }} // Animation properties on load
              transition={{ duration: 0.5, delay: 0.4 }} // Animation duration and delay
            />
          </div>

          {/* Use the About component */}
        </section>
        <section className='about-us'>
          <About />
        </section>
        <section className='models'>
          <Model />
        </section>
        <section className='footer'>
          <Footer />
        </section>
      </main>
    </div>
  );
}

export default Home;
